import { CircleAlert } from 'lucide-react';
import { useId, type Ref, type TextareaHTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

export interface AreaTextoProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  rotulo: string;
  dica?: string;
  erro?: string;
  ref?: Ref<HTMLTextAreaElement>;
}

/** Texto longo (observações), com quebra de linha automática e o mesmo padrão acessível do Campo. */
export function AreaTexto({
  rotulo,
  dica,
  erro,
  required,
  className,
  id,
  ...props
}: AreaTextoProps) {
  const idGerado = useId();
  const idCampo = id ?? idGerado;
  const idDica = dica ? `${idCampo}-dica` : undefined;
  const idErro = erro ? `${idCampo}-erro` : undefined;
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={idCampo} className="text-sm font-medium text-texto">
        {rotulo}
        {required && (
          <span className="ml-0.5 text-perigo" aria-hidden="true">
            *
          </span>
        )}
      </label>
      <textarea
        id={idCampo}
        required={required}
        rows={4}
        aria-invalid={erro ? true : undefined}
        aria-describedby={[idDica, idErro].filter(Boolean).join(' ') || undefined}
        className={cn(
          'rounded-lg border border-borda bg-superficie px-3 py-2 text-texto placeholder:text-texto-suave',
          erro && 'border-perigo',
          className,
        )}
        {...props}
      />
      {dica && (
        <p id={idDica} className="text-sm text-texto-suave">
          {dica}
        </p>
      )}
      {erro && (
        <p id={idErro} className="flex items-center gap-1.5 text-sm text-perigo">
          <CircleAlert className="size-4 shrink-0" aria-hidden="true" />
          {erro}
        </p>
      )}
    </div>
  );
}
